import { Tooltip } from "@mui/material";
import { type FC, useState } from "react";
import { Pencil } from "../../../../../styles/icons/pencil";
import {
  type SlackAlias,
  type SlackAliasWithDefault,
} from "../../../../slack/server/slack-supabase-service";
import { SlackAliasForm } from "./alias-form";

export const EditAction: FC<{
  alias: SlackAliasWithDefault;
  onComplete: (alias: SlackAlias) => void;
}> = ({ alias, onComplete }) => {
  const [openEdit, setOpenEdit] = useState(false);

  return (
    <>
      <Tooltip title="Edit this alias" placement="top" sx={{ cursor: "pointer", mr: 1 }}>
        <Pencil fontSize="small" color="info" onClick={() => setOpenEdit(true)} />
      </Tooltip>
      <SlackAliasForm
        onComplete={onComplete}
        existing={alias}
        open={openEdit}
        close={() => setOpenEdit(false)}
      />
    </>
  );
};
